module.exports = __webpack_public_path__ + "assets/woman@2x.png?v=5ed2e0794506a9dd14c34b93d1c2698c";